// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_pc-0";
export var discountCodeInput = "_pc-1";